import type { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../utils/constants";

/**
 * Everything the contact detail page derives from the contact row that must be
 * re-read after the contact is edited.
 *
 * The two SMS queries are keyed by contact id only, so editing the primary phone
 * on the mounted page would otherwise leave the SMS status, the header badge and
 * the consent editor's guard describing the previous number until a refocus or
 * reload (external audit bb8d065f, minor finding). The consent editor's own save
 * already invalidates the same two keys.
 */
export const contactEditRefreshKeys = (contactId: string) =>
  [
    [QUERY_KEYS.CONTACTS, contactId],
    ["sms-single-status", contactId],
    ["sms-consent-status", contactId],
  ] as const;

export function refreshContactAfterEdit(
  queryClient: QueryClient,
  contactId: string,
): Promise<void[]> {
  return Promise.all(
    contactEditRefreshKeys(contactId).map((queryKey) =>
      queryClient.invalidateQueries({ queryKey: [...queryKey] }),
    ),
  );
}
